import { Controller } from "@hotwired/stimulus"

// Turns a pick from the shared emoji picker into a real form submit, so choosing a
// home's icon goes through the ordinary PATCH + redirect.
//
// The picker (shared/_reaction_picker + emoji_picker_controller) is mounted in its
// event-only mode here — no react_url — so it POSTs nothing itself and only
// dispatches "emoji-picker:picked". That is the point: a home's icon shows in the
// switcher badge as well as in this modal, and a redirect leaves both correct
// without this controller having to know where every copy of it lives.
export default class extends Controller {
    static targets = ["field"]

    apply(event) {
        const emoji = event.detail?.emoji
        if (!emoji || !this.hasFieldTarget) return

        this.fieldTarget.value = emoji
        this.fieldTarget.form?.requestSubmit()
    }
}
